import request from "@utils/request";
import { ReturnType } from "./types";

export class CodSettlementApi {
  /**
   * List COD settlements
   */
  async list(args?: { params?: any; state?: string }) {
    const config: ReturnType = {
      url: "cod-settlements",
      method: "get",
      authorization: true,
      params: args?.params,
      config: { showErr: true },
    };
    if (args?.state) config.config.store = { key: args.state, action: "set" };
    return request(config);
  }

  /**
   * Admin approves or rejects a settlement
   */
  async updateStatus(id: number, status: string, notes?: string) {
    const config: ReturnType = {
      url: `cod-settlements/${id}/status`,
      method: "patch",
      authorization: true,
      data: { status, notes },
      config: { showErr: true },
    };
    return request(config);
  }

  /**
   * Admin directly collects cash
   */
  async createAdminDirect(payload: {
    deliveryManId: number;
    amount: number;
    paymentMethod: string;
    referenceId?: string;
    notes?: string;
  }) {
    const config: ReturnType = {
      url: "cod-settlements/admin",
      method: "post",
      authorization: true,
      data: payload,
      config: { showErr: true },
    };
    return request(config);
  }

  /**
   * Driver sends cash to admin (submits request with proof)
   */
  async createDriverRequest(payload: {
    amount: number;
    paymentMethod: string;
    referenceId?: string;
    proofImage?: string;
    notes?: string;
  }) {
    const config: ReturnType = {
      url: "cod-settlements/delivery",
      method: "post",
      authorization: true,
      data: payload,
      config: { showErr: true },
    };
    return request(config);
  }
}

export const CodSettlement = new CodSettlementApi();
